import React from 'react'
import { Link, useHistory } from 'react-router-dom'

const WelcomeIntroContainer = (props) => {
  const history = useHistory()

  const onEnableNotifications = async () => {
    window.bridge.authorizeNotifications()
    history.push('/mobile/welcome/calendar')
  }

  return (
    <div className="screen welcome">
      <div className="navigation-bar">
        <div className="title">Notifications</div>
      </div>
      <div className="content-flex">
        <div style={{ flex: 1 }} />
        <img
          style={{ width: '90vw', maxWidth: 400, margin: 'auto' }}
          src={require('../images/setup_notifications.png')}
          alt="poster"
        />
        <div style={{ flex: 1 }} />
        <p style={{ textAlign: 'center' }}>
          Enable notifications and we’ll remind you to complete exercise sessions and keep up with
          your plan.
        </p>
        <div style={{ flex: 1.8 }} />
        <button className="black block" onClick={onEnableNotifications}>
          Enable Notifications
        </button>
        <Link className="skip" to="/mobile/welcome/calendar">
          Skip this Step
        </Link>
      </div>
    </div>
  )
}

export default WelcomeIntroContainer
